let zh = {
  "common": {
    //公共翻译
    "returnButton": "返回",
    "okButton": "OK",
  },
  //主页
  "home": {
    "myLesson": "我的课程",
    "learningAnalysis": "学情分析",
    "courseConditions": "学情统计",
    "learningProcess": "学习进度",
    "performanceAnalysis": "成绩分析",
    "liveMessage": "直播信息",
    "notLogin": "登录",
    "faceIn": "人脸识别登录",
    "accountIn": "账号密码登录",
    "accountOrEmail": "邮箱/客户ID",
    "passwordDigits": "密码(包含大写字母，小写字母和数字混合的８～１６位)",
    "rememberMe": "记住我",
    "forgetPass": "忘记密码",
    "identifyStart": "开始识别",
    "immediateLogin": "立即登录",
    "courseName": "课程名称",
    "teachingTime": "授课日期",
    "status": "状态",
    "clickJump": "参与",
    "userProtocol": "《用户隐私政策及服务协议》",
    "operation": "操作说明",
    "faq": "常见问题",
    "service": "服务条款",
    "policy": "隐私协议",
    "keepLogin": "保持登录状态",
    "support": "服务支持",
    "schcourseConditions": "学情统计(计划)",
    "schperformanceAnalysis": "成绩分析(计划)",   
    "welcome": "欢迎访问StudyArts！",
    "selectCompanyTitle": "请选择要登录的企业。",
  },
  //错误显示画面
  "err": {
    "err1": "画面转换中发生了错误。",
    "err2": "请注销一次，关闭浏览器，过一段时间后再次尝试。",
    "err3": "另外，错误没有消除的情况下请到StudyArts支持中心咨询。",
    "err4": "访问数据时出现问题。联系学习艺术团队了解更多信息",
    "revertErr": "返回首页",
  },
  //学习详情页
  "aicourse": {
    "beginLearn": "开始",
    "endLearn": "结课申请",
    "timeLength": "课程时长",
    "week": "周",
    "weekPlan": "每周按",
    "hoursPre": "小时预估",
    "beforeKnowledge": "先修知识",
    "distinguish": "区分",
    "courseLanguage": "课程语言",
    "classification": "分类",
    "category": "课程分类"
  },
  //
  "courseScoreStatistics": {
    "beginLearningTime": "开始学习时间",
    "validityPeriod": "课程有效时间",
  },
  //community
  "community": {
    "content": "暂无内容",
    "dataNone": "暂无错题数据",
    "down": "下载",
  },
  //成绩分析页
  "scoreStatistics": {
    "performanceAnalysis": "成绩分析",
    "schPerformanceAnalysis":"成绩分析(计划)",
    "courseName": "课程名称",
    "courseNameInput": "请输入课程名称",
    "validityPeriod": "课程有效期",
    "chooseDate": "选择日期",
    "search": "查询",
    "studentsCounst": "参考人数",
    "myScore": "我的成绩",
    "aveScore": "平均成绩",
    "maxPoint": "最高分",
    "minPoint": "最低分",
    "point90": "合格",
    "point80": "不合格",
    "personCount": "人数",
    "proportion": "比例",
    "passPercent": "合格标准",
    "judge": "考试结果",
    "message1": "最好成绩",
    "message2": "",
    "message3": "※平台课为非成绩分析对象",
    "result": "结果",
    "testName": "测试名称",
    "finalExam": "期末考试",
  },
  "curriculum": {
    "exam": "考 试",
    "errorCollection": "错题本",
    "questionnaire": "问卷调查",
    "scoreStatistics": "成绩分析",
    "gotoLive": "进入直播",
    "question": "问卷调查",
    "covenant": "保证书",
    "thi__giua__ki": "期中考试"
  },
  "curriculumExam": {
    "listExam": "测试清单",
    "passExam": "合格率",
    "failExam": "不合格率",
    "doNotExam": "未完了",
    "rank": "排行榜",
    "doingExam": "考试期间无法确认成绩"
  },
  //开始考试页
  "examBegins": {
    "center": "Examination Center",
    "notice": "考试须知",
    "introduce": "考试介绍",
    "first": "考试针对所学课程的掌握情况进行评估；",
    "second": "考试题型为单选题，多选题，填空题和解答题；",
    "third": "确定掌握课程所有内容后再进行考试，否则会影响考试成绩；",
    "rule": "考试规则",
    "one": "在规定时间内完成答题；",
    "two": "未填写答案的题判定为错题；",
    "three": "确认答题无误后请点击提交按钮提交答案；",
    "remain": "已考次数",
    "current": "当前成绩",
    "highest": "最高成绩",
    "begin": "开始考试",
    "giveUp": "放弃考试",
    "notice_exam": "考试注意事项",
    "notice_midterm": "考试注意事项",
    "type": "Display Type",
    "notFull": "Show each sentence",
    "full": "Show all",
    "changeTypeShow": "变更显示模式"
  },
  "examResume": {
    "resume": "考试历史",
    "point": "考试分数",
    "time": "考试时间",
    "jump": "前往教学页",
  },
  "detailExam": {
    "finalExam": "期末考试",
    "seconds": " 秒",
    "minutes": " 分钟",
    "fullMark": "考试总分",
    "standardMark": "合格标准",
    "yourMark": "得分",
    "pass": "合格",
    "fail": "不合格",
    "viewDetailWrong": "不正解問題の詳細",
    "viewChapter": "按章节的得分",
    "totalRightAnswer": "正确问题数",
    "totalScore": "得分"
   },
  //错题集页
  "errorBook": {
    "errorBook": "错题本",
    "prve": "上一页",
    "next": "下一页",
    "answerInput": "请输入您的答案......",
    "answer": "我的答案",
    "rightAnswer": "正确答案",
    "answerAnalysis": "答案解析",
    "download": "错题导出",
    "remove": "错题移除",
    "confirmMessage": "确认要移出错题本吗？",
  },
  "previewBook":{
    "previewBook": "结业考试预览",
  },
  "active": {
    "goHome": "前往首页",
  },
  //
  "email": {
    "title": "密码重置",
    "email": "请输入您的邮箱账号",
    "emailWarning": "※ 对于使用用户ID访问本系统的客户而言，无法使用此功能。如果您想要重置密码，请联系用户ID的管理员。",
    "placeholder": "请输入您的邮箱账号",
    "confirmplaceholder": "请再次输入邮箱账号",
    "confirm": "发送",
    "message": "两次输入的邮箱账号不一致",
  },
  "register_email": {
    "title": "已发送密码重置邮件",
    "message": "已经向您的邮箱发送了邮件，请访问邮件中记载的URL并根据页面提示进行密码变更。",
    "passwordResetSuccess": "重置密码成功，请前往首页重新登录。",
    "timeout": "重置密码的URL已经失效，请点击登录页面的「忘记密码」重新进行密码重置的申请。",
    "checkMessage": "两次输入密码不一致。",
  },
  "courseList": {
    "courseName": "课程名称",
    "courseNameInput": "请输入课程名称",
    "validityPeriod": "课程有效期",
    "chooseDate": "选择日期",
    "to": "至",
    "no": "序号",
    "operation": "操作",
  },
  "courseProgress": {
    "learningProcess": "学习进度",
    "search": "查询",
    "learnBeginDate": "学习开始日期",
    "complete": "课节总数",
    "uncomplete": "未完成课节",
    "examhistory": "考试履历",
    "isquestion": "问卷调查",
    "look": "查看",
  },
  "personSet": {
    "changePass": "更改密码",
    "personInfo": "个人信息",
    "messageCenter": "消息中心",
    "changeFace": "修改头像",
    "chooseImg": "选择图片",
    "save": "保存",
    "off": "取消",
    "confirm": "OK",
    "currentPass": "当前密码",
    "newPass": "新密码",
    "repeatPass": "重复密码",
    "notMessage": "暂无消息",
    "noticeTime": "通知时间",
    "noticeTittle": "通知题目",
    "status": "状态",
    "unread": "未读",
    "read": "已读",
    "userName": "用户名",
    "email": "电子邮件",
    "mobile": "移动电话",
    "change": "OK",
    "passwordNotNull": "新密码不能为空",
    "oldPasswordIncorrect": "旧密码不正确",
    "passwordChangeFail": "密码修改失败",
    "imgSuccess": "头像修改成功！",
    "placeholder": "请输入包含大写字母，小写字母和数字混合的８～１６位的密码。",
    "defaultLanguage": "默认系统语言",
    "imageError": "请选择支持的扩展名（gif,jpeg,jpg,png,bmp）",
    "birthday":"生日",
    "occupation":"职业",
    "synopsisUser": "自己绍介",
    "synopsisNonUser": "您尚未设置自我介绍。",
    "enterName": "请输入你的名字。",
    "editInfoUser": "编辑个人信息",
    "enterSex": "选择性別。",
    "enterMobile": "请输入联系方式。",
    "enterJob": "请输入职业。",
    "enterSynopsis": "请输入您的个人信息。",
    "personInfoSanritsu": "购课信息",
  },
  "contactUs": {
    "contactUs": "联系我们",
    "email": "您的电子邮箱",
    "send": "发送",
    "problem": "请输入您的问题",
    "sucess": "发送成功",
    "sure": "确认号",
    "sorry": "我们愿意为您解答任何疑惑。如果我们的产品及服务给您带来任何困扰，我们深表歉意。",
    "gohome": "返回首页",
    "faild": "发送失败",
    "sever": "很抱歉，服务器开小差了，再试试吧",
    "resend": "重新发送",
  },
  //课程一览页
  "schoolBusiness": {
    "sloganFour": "My Courses",
    "all": "全部",
    "introduceThree": "Don't miss out on business",
    "introduceFour": "Enroll in a course and build your best future, today.",
    "beginLearn": "回到顶部",
    "elective": "选修",
    "generalCourse": "课程",
    "privateCourse": "套餐课程",
  },
  "search": {
    "keyWord": "请输入关键词",
    "result": "暂无搜索结果",
  },
  "studySituationList": {
    "count": "学情统计",
    "validityPeriodStart": "开始时间",
    "validityPeriodEnd": "结束时间",
    "distinguish": "区分",
    "studentEndDate": "学习结束日期",
    "guarantee": "保证书",
    "certificate": "证书",
    "notRaised": "未提出",
    "raised": "提出",
  },
  "schStudySituationList": {
    "count":"学情统计(计划)",
    "validityPeriodStart": "开始预定日",
    "validityPeriodEnd": "结束预定日",
    "learnBeginDate": "学习开始日",
    "learnEndDate": "学习结束日",
    "learningProcess":"学习进度",
    "completionStatusFlag":"线下完成状态",
    "offlineCompleteTime":"完成日",
    "isDelay":"延迟状况",
    "finish": "完成",
    "undone": "未完成",   
    "delay": "延迟",
    "noDelay": "未延迟",   
  },
  "task_answer": {
    "answerCommit": "提交答案",
    "examCommit": "提交试卷",
    "answer": "回答",
  },
  "task_result": {
    "prev": "上一题",
    "next": "下一题",
    "wrong": "回答错误",
    "reght": "回答正确",
    "answer": "参考答案",
    "analysis": "试题分析",
    "question": "問",
    "unShowAnswer": "您没有权限查看本问题的解答内容。",
  },
  "rePassword": {
    "newPassword": "新密码(包含大写字母，小写字母和数字混合的８～１６位)",
    "repeact": "重复密码(包含大写字母，小写字母和数字混合的８～１６位)",
    "confirm": "确认修改",
  },
  "read": {
    "catalogue": "目录",
    "note": "笔记",
    "chat": "评论",
    "tips": "在这里记下对课程的心得与体会吧",
    "login": "请登录",
    "save": "保存",
    "jump": "前往",
    "page": "页",
    "prev": "上一个",
    "next": "下一个",
    "returnCatalogue": "返回目录"
  },
  "week": {
    "status": "完成状态",
    "exercise": "练习",
    "score": "成绩",
    "undone": "未学",
    "done": "学到了",
    "studing": "学习"
  },
  "questionnaire": {
    "questionnaire": "问卷调查",
    "contentInput": "请输入内容",
    "submit": "提交",
    "tempSave": "暂时保存",
    "tempSaveHint1": "是否要暂时保存输入内容？",
    "tempSaveHint2": "注意：如果您更换浏览器或设备，您暂时保存的输入内容将会消失。",
    "noticeSuccess": "当前输入内容保存成功。",
  },
  "js": {
    "confirm": "确定",
    "quite": "确认退出?",
    "hint": "提示",
    "cancel": "取消",
    "userNameNull": "用户名不能为空",
    "email": "请输入邮箱地址",
    "formatWrong": "邮箱格式错误",
    "passwordNull": "密码不能为空",
    "passwordFormat": "请输入大小写字母及数字混合的８～１６位的密码。※不支持「_+-=*#%$」以外的特殊字符。",
    "repeatPassword": "重复密码不能为空",
    "different": "两次密码输入不一致",
    "service": "请确认用户服务协议",
    "account": "请输入账号!",
    "password": "请输入密码!",
    "beginLearning": "您确定要开始吗？",
    "dataNone": "暂无数据",
    "jumpToexam": "请先完成课程后再进行考试!",
    "examDataNone": "暂无考试数据!",
    "certificateDataNone": "未登录证书相关信息！",
    "jumpToQuestion": "请先完成「考试」后再进行问卷调查!",
    "jumpToErrorBook": "请先完成考试后查看错题本!",
    "loginPlease": "请登录",
    "lastExam": "最近一次考试未出成绩，暂时不能再次考试!",
    "no": "第",
    "placeholder": "在此输入",
    "examOver": "考试结束，将自动提交试卷",
    "emailNone": "该邮箱账号不存在,请重新输入！",
    "sendSuccess": "发送成功！",
    "returnHome": "返回首页",
    "problemInput": "请输入您的问题",
    "submitConfirm": "确定要提交练习题吗？",
    "noLive": "现在没有直播！",
    "PleaseLogin": "请先登录系统。",
    "submitHint": "请确保所有填写内容均为您的真实意见，感谢您的反馈。",
    "nonull": "问卷调查有未记录的内容，请填写全部调查内容。",
    "nocorrect": "您上次考试批改未完成，暂不能考试！",
    "mostPage": "超过最大页数！",
    "leastPage": "超过最小页数！",
    "saveNotes": "确定：保存笔记",
    "unSaveNotes": "取消：不保存笔记",
    "dontSave": "您当前未保存笔记",
    "wordMore": "超出最大字数！",
    "saveSuccess": "保存成功",
    "PleaseLogin": "您当前尚未登录，请先登录系统再开始学习。",
    "nonull": "您有未参与的调查内容，请参与全部调查内容再提交！",
    "systemError": "发生系统异常",
    "userNotExist": "用户不存在",
    "passwordWrong": "密码错误",
    "passErrorTimer": "密码输入错误次数达到五次，账号将被锁定10分钟，请10分钟后重试。",
    "passLock": "账号已被锁定10分钟，请稍后重试！",
    "failMatch": "未能匹配到用户请调整后重试",
    "faceFail": "人脸识别失败",
    "AccecpProtocol": "请先阅读并接受用户协议及隐私政策",
    "submitConfirmTest": "确定要提交考试吗？",
    "submitConfirmExam": "您确定要提交期中考试吗？",
    "submitSuccessExam": "你已经完成了期中考试。 请点击“成就”按钮查看结果。",
    "submitSuccessTest": "考试已提交。请通过考试-当前成绩查看结果。",
    "submitSuccessTask": "练习已提交。请通过目录-练习成绩查看结果。",
    "uncheckMessage": "保证书有未填写项目，请全部填写完成再提交。",
    "networkErr":"发生了网络通信异常。",
    "confirmSaveNotes": "您的笔记已更改。是否要保存当前笔记？",
    "confirmJoinCourseOnline": "你想参加这个课程吗？",
    "alertCourseOnlineEnd": "抱歉，本课程已结束。",
    "exerciseMsg": "确认提出练习题的答案吗？",
    "commonCourseMessage":"您已参加本课程的全局课程「{1}」，继续学习本课程将清除全局课程的相关数据，是否继续？",
    "downloadPdfFalse": "下载丢失的发票。您需要重新注册课程以便进行发票导出。",
    "registerApplyCourseFalse": "课程申请过程中出现预想外错误，非常抱歉。请重启浏览器尝试再次课程申请。"
  },
  "new": {
    "title1": "精品课程",
    "title2": "设置",
    "title3": "更多",
    "title4": "换一换",
    "title5": "搜索结果",
    "title6": "全部",
    "title7": "已结束",
    "title8": "正在直播",
    "title9": "未开始",
    "title10": "选择全部",
    "title11": "取消选择全部",
    "title12": "笔记导出",
    "title13": "答题卡",
    "title14": "总题数",
    "title15": "已答题数",
    "title16": "用时",
    "title17": "您正在使用系统提供的初始密码，为了您的账号安全，请尽快修改密码！谢谢。",
    "title18": "新密码和旧密码不能相同！",
    "title19": "结课申请",
    "title20": "学习开始",
    "title21": "学习结束",
    "title22": "课程完成",
    "showCompletedCourse": "包含已结课信息",
    "title24": "考试总分",
    "title25": "修改",
    "title26": "您尚未参加考试，不能查看成绩！",
    "title27": "您的考试未批改不能查看成绩！",
    "title28": "当前密码不能为空",
    "title30": "有未学习的内容！",
    "title31": "放弃练习",
    "title32": "确定要放弃练习吗？",
    "title33": "问卷调查",
    "title34": "申请",
    "title35": "确定要提交结课申请吗？",
    "title36": "结课申请已提交。可点击「结课申请」查看申请结果。",
    "title37": "确定要再次考试吗？",
    "title38": "（※合格判定以最新一次考试成绩为准）",
    "title39": "跳转",
    "title40": "该课程尚未开始，敬请期待！",
    "title41": "您不在该课程的有效期间内，暂不能访问该课程，请联系管理员。",
    "title42": "有未作答的题目，确定要提交练习吗？",
    "title43": "密码修改成功，请重新登录。",
    "title44": "有效时间",
    "title45": "",
    "title46": "请先确认「保证书」后再进行问卷调查!",
    "title47": "请先完成课程后再进行问卷调查!",
    "title48": "请先完成「考试」后再确认保证书!",
    "title49": "请先完成课程后再确认保证书!",
    "title50": "进度确认",
    "title51": "学员姓名",
    "title52": "所属地区",
    "title53": "活用部门",
    "title53_1": "活用部门",
    "title54": "所属机构",
    "title54_1": "所属机构",
    "title55": "退场日",
    "title56": "是否必修",
    "title57": "学习进度",
    "title58": "最新结果",
    "title59": "是否合格",
    "title60": "学习开始日",
    "title61": "学习完成日",
    "title62": "完成章节数",
    "title63": "未完章节数",
    "title64": "保证书",
    "title65": "问卷调查",
    "title66": "结课申请",
    "title67": "包含退场者",
    "title68": "学习进度统计",
    "title69": "请输入学员姓名",
    "title70": "EXCEL文件导出",
    "title71": "请选择活用部门",
    "title72": "请选择所属机构",
    "title73": "请选择是否必修",
    "title74": "0",
    "title75": "100",
    "title76": "请选择是否合格",
    "title77": "进度范围",
    "title78": "请选择结课申请",
    "title79": "导出",
    "title80": "请选择所属地区",
    "title81": "课程尚未发布。由于内容还有可能被变更。所以「考试」功能尚不能使用。",
    "title82": "课程尚未发布。由于内容还有可能被变更。所以「问卷调查」功能尚不能使用。",
    "title83": "课程尚未发布。由于内容还有可能被变更。所以「保证书」功能尚不能使用。",
    "title85": "清除",
    "title86": "信息",
    "title87": "您必须先完成此视频，然后才能转到下一页 !",
    "title88": "本章无内容！",
    "title89": "此内容目前不可用。请稍后再试 ！",
    "title90": "您无法查看课程详情，因为您不是这门课程的负责老师!",
    "title91": "本课的依存课程「{0}」尚未学习完成，暂不能访问该课程 !",
    "title92": "请在本课程的依存课程「{0}」结束的{1}天后，再进行学习。",
    "title93": "抱歉，您还不能访问此页面，因为您还没有任何课程！",
    "title94": "抱歉，您无法查看详细信息，因为该学员尚未参加该课程！",
    "title95": "今天",
    "title96": "打扰一下。 没有期中考试，所以请稍后重新访问。",
    "title97": "你不能参加期中考试，因为你在参加期末考试",
    "title98": "不能参加期末考试，因为你正在参加期中考试",
    "title99": "你正在参加期末考试。你想继续吗？",
    "title100": "你正在参加期中考试。你想继续吗？",
    "title101": "您正在服用另一种期中考试。开始此期中考试之前，请先完成！",
    "title102": "对不起，您不能参加这次期中考试，因为这次考试没有问题！",
    "title103": "错题数",
    "title104": "你不能做练习，因为你还没有完成内容。",
    "title105": "由于测验没有合格，所以无法参加最终考试。",
    "title106": "您不能开始这门课程，因为您不是这门课程的学员。",
    "title107": "您无法完成本课程，因为您不是本课程的学员。",
    "title108": "您将无法看到该课程的详细信息，因为该课程尚未注册任何内容",
    "title109": "此帐号已被禁用！",
    "title110": "您无法完成该课程，因为您不是该课程的学员。",
    "title111": "学习进度_",
    "title112": "由于该学员从未参加过考试，因此无法导出考试成绩文件。",
    "title113": "由于本课程没有学员参加考试，因此无法导出考试成绩文件。",
    "title114": "该学员未被设置为直播课的学员，无法导出考勤信息。",
    "title115": "问题集",
    "title116": "列表",
    "title117": "热门课程",
    "title118": "经常选择的课程",
    "title119": "最新课程",
    "title120": "StudyArts推荐课程",
    "title121": "¥",
    "title122": "您的成绩",
    "title123": "错题详细",
    "title124": "确认",
    "title125": "本次考试的成绩正在批改中。成绩批改后请点击[成绩]按钮进行确认。",
    "title126": "需要再次确认的问题集",
    "title127": "再确认",
    "title128": "需要再次确认的问题集",
    "title129": "表示",
    "title130": "最新课程",
    "title131": "热搜课程",
    "title132": "StudyArts推荐课",
    "title133": "按课程分类",
    "title134": "配置",
    "title135": "热搜",
    "title136": "好评",
    "title137": "按价格升序",
    "title138": "按价格降序",
    "title139": "最新",
    "title140": "课程的设置",
    "title141": "学员",
    "title142": "加入购物车",
    "title143": "课程购入申请",
    "title144": "团购价格",
    "title145": "学习预定时间",
    "title146": "时间",
    "title147": "课件",
    "title148": "折扣有效期",
    "title149": "学员数",
    "title150": "课程详细内容",
    "title151": "目录",
    "title152": "空购物车",
    "title153": "课程的价格",
    "title154": "章节",
    "title155": "合计购入金额",
    "title156": "关联课",
    "title157": "本课程在购物车中已经存在。",
    "title158": "学员的评论",
    "title159": "追加课程评论",
    "title160": "关于本课程的评价",
    "title161": "发送反馈",
    "title162": "申请",
    "title163": "学习开始",
    "title164": "付款",
    "title165": "转账信息",
    "title166": "银行账号",
    "title167": "银行名称",
    "title168": "金额",
    "title169": "转账内容",
    "title170": "姓名",
    "title171": "和邮件/用户ID",
    "title172": "电话号码",
    "title173": "注意：转账时，请准确填写StudyArts转账内容中的付款码。",
    "title174": "购入课程信息",
    "title175": "打折前价格",
    "title176": "折扣价格",
    "title177": "购入金额",
    "title178": "课程购入完成。",
    "title179": "您已完成 StudyArts 课程的申请。待管理员完成注册信息审核后，我们将第一时间向您发送注册详情相关通知。",
    "title180": "以防万一，请保存好转账内容（付款码）。",
    "title181": "返回首页",
    "title182": "课程购买申请",
    "title183": "学习申请",
    "title184": "因为没有学员参加此直播课，所以无法导出出勤信息。",
    "title185": "因为没有数据所以无法导出文件。",
    "title186": "HOT课程",
    "title187": "由于该账号正在另一台设备上参加考试，所以请重新开始。",
    "title188": "如果要在此设备・浏览器中参加考试，必须从头开始。",
    "title189": "课程分类",
    "title190": "计划分类",
    "title191": "您的提交没有成功。 请检查网络连接或直接联系我们。",
    "title192": "本课程属于计划课程，请到计划课程进行确认。",
    "title193": "错题本",
    "title194": "该学员没有本次考试的错题信息。",
    "title195": "该课程在购物车中已经存在。",
    "title196": "继续购买",
    "title197": "我们还没有对这门课进行评价。",
    "title198": "请输入评论信息。",
    "title199": "请输入姓名。",
    "title200": "请输入邮箱。",
    "title201": "请输入电话号码",
    "title202": "请输入正确的电话号码",
    "title203": "隐藏",
    "title204": "银行账号",
    "title205": "转账金额",
    "title206": "申请信息",
    "title207": "保存本课程",
    "title208": "X",
    "title209": "已删除全部错题！",
    "title210": "考试期间如果切换浏览器或设备，将不会保存您的答案。",
    "title211": "选修课",
    "title212": "课程介绍",
    "title213": "负责老师介绍",
    "title214": "自由",
    "title215": "免费课程",
    "title216": "请先完成「考试」，再确认「保证书」。",
    "title217": "请选择问卷调查的复选框后再提交问卷调查。",
    "title218": "确定将该学员设置为出席状态吗？",
    "title219": "注意",
    "title220": "特色课程",
    "title221": "所有类别",
    "title222": "修了コース",
    "title223": "银行账户",
    "title224": "已选课程",
    "title225": "搜索课程",
    "title226": "其他銀行",
    "title227": "筛选",
    "title228": "注册确认",
    "title229": "删除",
    "title230": "名前",
    "title231": "匿名",
    "title232": "コメントをここに入力してください。",
    "title233": "Study-Arts",
    "title234": "邮件/用户ID确认",
    "title235": "邮件和邮件确认的内容不匹配。",  
    "title236": "注册同意书",
    "title237": "拒绝注册",
    "title238": "接受",
    "title239": "拒绝",
    "title240": "预览",
    "title241": "请输入正确的姓名",
    "title242": "请输入正确的邮件",
    "title243": "该邮件已经注册完毕。请使用另一个新的邮件注册，或用该邮件登录后继续申请课程。",
    "title244": "该课程已申请。",
    "title245": "请输入确认邮件",
    "title246": "邮件",
    "title247": "邮件确认。",
    "title248": "否",
    "title249": "必填项目尚未填写（浅粉背景色处）。请填写后再次提交。",
    "title250": "非常感谢您购买我们的网课。请您通过邮件或下载付款通知单后确认内容。",
    "title251": "按付款通知单上流程尽快付款。付款后我们会把系统登录信息通过邮件发给您。",
    "title252": "申请者姓名:",
    "title253": "电子邮件地址:",
    "title254": "申请地区",
    "title255": "地区编号：",
    "title256": "地区名称：",
    "title257": "付款通知单下载",
    "title258": "地域代码",
    "title259": "同学",
    "title260": "发行日",
    "title261": "年",
    "title262": "月",
    "title263": "日",
    "title264": "学费汇款请求书",
    "title265": "请求汇款金额",
    "title266": "项目",
    "title267": "金额",
    "title268": "学习期间",
    "title269": "① 从以下付款方式中选择一种",
    "title270": "微信支付：微信扫码以下二维码，上传本缴费通知书、",
    "title285": "输入汇款人相关信息，实时汇率，手续费 1.3%。",
    "title271": "② 海外汇款：通过银行汇款到以下本校账户。",
    "title272": "円",
    "title273": "申请地区：",
    "title274": "购课信息确认",
    "title275": "请确认以下的购课信息。",
    "title276": "确认购课信息无误后，请您选择申请地区点击课程购买按钮购课",
    "title277": "申请番号",
    "title278": "明细",
    "title279": "※请汇款人支付海外汇款所需要的银行汇款手续费用。",
    "title280": "修正不可",
    "title281": "※关于付费通知单如果您有疑问请拨打以下电话咨询。",
    "title282": "咨询电话：",
    "title283": "课程名称：",
    "title284": "您这次申请的课程中、有已经申请完毕的课程包含在内，请您再检查一下申请对象课程有没有错误。",
    "title290": "如果核实没有问题想就这样申请的话、请你按「申请」按钮。",
    "title289": "但是，请注意该课程过去的申请信息将会会被覆盖。",
    "title286": "申请",
    "title287": "取消",
    "title288": "网课付款通知单_",
    "title291": "免费",
    "title292": "购课",
    "title293": "信息确认",
    "title294": "导出研究进展"
  },
  "manage": {
    "look": "查看",
    "discription": "概述",
    "students": "学员名单",
    "lessons": "课程列表",
    "detail": "详情",
    "student": "学员管理",
    "lesson": "课程管理",
    "questions": "问题清单",
    "sex": "性別",
    "lesson_begin": "未开始的课程",
    "lesson_learning": "学习期间的课程",
    "lesson_end": "结束课程",
    "default": "所有课程",
    "manage_info": "信息管理",
    "download": "下载",
    "coursesOnline": "学员人数",
    "downloadStudents": "导出学员名单",
    "attendance": "出勤管理",
    "presentList": "出席学员名单",
    "absentList": "缺席学员名单",
    "statusAttendance": "考勤狀態",
    "present": "出勤率",
    "absent": "缺席"
  },
  "manage_questions": {
    "questions_id": "问题编号",
    "questions_content_title": "问题内容",
    "questions_audio": "声音的",
    "questions_video": "视频",
    "questions_image": "图像",
    "questions_created": "我自己创建的",
    "chosse_questions": "请选择试题类型",
    "chosse_questions_one": "单选题",
    "chosse_questions_more": "多选题",
    "questions_writing": "解答题",
    "chosse_answer_more": "多重问题",
    "chosse_status_questions": "试题用途",
    "questions_exercise": "练习",
    "questions_test": "考试",
    "chosse_teacher_create": "请选择创建问题的老师",
    "chosse_chapter": "请选择章节",
  },
  "live_lesson": {
    "hiden": "隐藏搜索区域",
    "display": "显示搜索区域",
  },
  "profile": {
    "name": "学员姓名",
    "sex": "性别",
    "email": "电子邮件",
    "statistic": "统计",
    "sum_lesson": "总课程数",
    "lesson_begin": "未开始的课程数",
    "lesson_learning": "正在学习的课程数量",
    "lesson_end": "完成的课程数",
    "detail_lesson": "课程详情",
    "course": "课程",
    "discription": "概述",
    "link": "网址链接",
    "studyTime": "参与时间",
    "showStatical": "汇总信息展示",
    "jonhLiveCourse": "现场讲座的出席人数",
    "noJonhLiveCourse": "直播课缺勤人数",
  },
  "manage_lesson": {
    "keyWord": "请输入课程名称",
    "lesson": "章节 ",
    "lesson_list": "课程目录",
    "total_lesson": "总章节数 ",
    "total_excercise": "测验总数",
    "total_student": "参加课程的学员总数",
    "statistical": "统计",
    "time_course": "课程时间",
    "teacher_charge": "导师",
    "status_course": "课程状态",
    "live_lesson": "学习",
    "not_stater": "没有开始",
    "not_open": "没有开始",
    "next_page_details": "内容详情",
    "info_course": "课程信息",
    "status1": "没学过的学员",
    "status2": "学习中的学员",
    "status3": "已学完的学员",
    "clear": "清除",
    "choose_date": "请选择问题创建日期",
    "static": "考试成绩",
  },
  "manage_student": {
    "lesson_normal": "学习课程",
    "lesson_test": "考试课程",
    "type": "分类",
    "time": "期间",
    "count_of_students": "学员人数",
    "teacher": "老师",
    "job": "职务",
    "mobile": "手机",
    "to_chuc": "用户组织",
    "level": "级别",
    "age": "生日",
    "area": "国家（语言）",
    "chi_nhanh": "所属部门",
    "male": "男",
    "female": "女",
    "charge": "担当",
    "not_charge": "非担当",
    "status": "地位",
    "person_charge": "经理",
    "me": "我",
    "not_me": "其他",
    "lesson_unlocked": "还没有参加课程",
    "lesson_locked_not_study_end": "学习中",
    "lesson_study_end_not_exam": "完成课程内容",
    "lesson_exam_doing": "考试进行",
    "lesson_exam_end": "期末考试成绩",
    "lesson_unpass": "失败",
    "lesson_pass": "经过",
    "lesson_tuyet_doi": "满分",
    "lesson_end": "终了",
    "app_sp": "应用与支持",
    "keyWord": "输入课程的标题或内容",
    "exam_not_me": "用户不是课程的学员",
    "live_time": "在线时间",
    "hour": "小时",
    "minute": "分钟",
    "export": "结果导出",
    "exportDiligent": "导出考勤信息",
    "noJonhLive": "不参与",
  },
  "statictical" : {
    "chapter_status": "章节状态",
    "total_chapter": "总章节数",
    "excercise_status": "测验状态",
    "total_excersice": "测验总数",
    "completed": "学到了",
    "unstudied": "未学",
    "studying": "学習中",
    "scored": "得分",
    "unscored": "不计分",
    "waiting_scoring": "等待得分",
  },
  "mid_term": {
    "mid_term": "期中考试",
    "choose_mid_term": "请选择一项期中考试",
  },
  "wrong_book": {
    "examList": "考試名单"
  },
  "preview": {
    "examList": "预览对象考试一览"
  },
  "comments": {
    "commentName": "评论列表",
    "titleStatus": "在非参与课程中包含评论",
    "content": "相关内容",
    "countConv": "评论数",
    "timeSeen": "最后查看时间",
    "detail": "细节"
  },
  "courseOnline": {
    "timeCourse": "课程时长",
    "comingSoon": "它很快就会开始",
    "title1": "你想参加的课程是[XXXXX]。",
    "title2": "开始本课程需要 XX 分钟。",
    "title4": "你想加入这个课程吗？",
    "attendance": "课程已结束，您无法参加。如果您临时换班并已完成学习，您可以按[XXX]参加该课程的考勤。",
    "comfirmRejoin": "你想参加这堂课吗？",
    "join": "考勤",
    "reBegin": "重新进入房间",
    "joinSuccess": "课程报名成功",
    "joinError": "参加课程失败",
    "btitle1": "请按[ XXX ① ] 或 [ XXX ② ]来参加直播课。",
    "btitle2": "打不开zoom时请按[ XXX ① ] 或 [ XXX ② ]。",
    "btitle3": "注意：如果您以这种方式访问，您的出席信息将不被统计。请在课程结束后手动更新出席信息。",
    "draft": "预备",
    "courseName": "直播课名称",
    "courseNameInput": "请输入直播课名称。",
    "quantityAlert": "该直播课的参加人数已达上限。"
  },
  "notification": {
    "title1": "这是您尚未开始的课程的通知。",
    "title2": "要开始课程查看公告内容吗？",
    "common": "您在以下位置收到了新通知",
  },
  "scoreStaticNew": {
    "noInformation": "没有相关学员的考试信息",
    "timeExamStart": "测试开始时间",
    "timeExamEnd": "考试结束时间",
    "timeExamConducted": "试験実施时间",
    "examDate": "试験开始日",
    "timeExamConductedNew": "试験実施时间",
  },
  "manual": {
    "changeLanguage": "语言变化",
    "searchCourse": "课程搜索",
    "personalInfo": "个人信息",
    "forgotPass": "如果您忘记密码",
    "changeAva": "个人资料照片更改",
    "changeInfo": "个人信息的变更",
    "changePass": "更改密码",
    "commentNoti": "新评论通知",
    "participation": "参与课程",
    "exercise": "练习",
    "markExercise": "测验率",
    "midTerm": "期中考试",
    "finalExam": "期末考试",
    "achievements": "等级确认",
    "wrongList": "错误的问题收集",
    "general": "常见的",
    "endCourse": "课程结束",
    "achievementStudent": "学员成绩",
    "settingProcedure": "设定说明书",
    "pwa": "移动端的操作说明手册",
    "infoAcc": "帐户信息",
    "jonhExam": "参加考试",
  },
  "scoreNew": {
    "title1": "按章节的得分",
    "title2": "正确率",
    "title3": "得分率",
    "title4": "章名",
    "title5": "总问题数",
    "title6": "正确问题数",
    "title7": "错误问题数",
    "title8": "得分",
    "title9": "考试成绩出力",
    "title10": "成绩详情",
  },
  "manualNew": {
    "type_1": "致初次使用本产品的人",
    "type_1_1": "使用电脑",
    "type_1_2": "使用手机・平板电脑",
    "type_2": "登入・登出",
    "type_2_1": "选择语言",
    "type_2_2": "登入",
    "type_2_3": "忘记密码",
    "type_2_4": "登出",
    "type_3": "课程学习",
    "type_3_1": "课程查询",
    "type_3_2": "我的课程",
    "type_3_3": "查看课件",
    "type_3_4": "期中考试",
    "type_3_5": "期末考试",
    "type_3_6": "成绩确认",
    "type_3_7": "保证书",
    "type_3_8": "问卷调查",
    "type_3_9": "笔记出力",
    "type_3_10": "结课申请",
    "type_4": "学情分析",
    "type_4_1": "学习情况",
    "type_4_2": "成绩确认",
    "type_5": "直播课",
    "type_5_1": "查询直播课",
    "type_5_2": "参加直播课",
    "type_6": "个人中心",
    "type_6_1": "修改头像",
    "type_6_2": "修改个人信息",
    "type_6_3": "修改系统语言",
    "type_6_4": "修改密码",
    "type_7": "管理功能",
    "type_7_1": "查看管理对象的进度情况",
    "type_7_2": "学员管理",
    "type_7_3": "课程管理",
    "type_7_4": "出席信息",
    "type_7_5": "直播课",
    "type_3_3_1": "♦ 开始课程",
    "type_3_3_2": "♦ 选择课程",
    "type_3_3_3": "♦ 上下移动课件",
    "type_3_3_4": "♦ 缩小/放大",
    "type_3_3_5": "♦ 笔记",
    "type_3_3_6": "♦ 评论",
    "type_3_3_7": "♦ 页面跳转",
    "type_3_3_8": "♦ 练习",
    "type_3_3_9": "♦ 显示练习得分",
    "type_3_3_10": "♦ 返回",
  },
  "codeStatus": {
    "code_1_99": "没有数据",
    "code_1_0": "正常",
    "code_1_1": "未开始",
    "code_1_2": "有效期外",
    "code_1_3": "依存课程「{0}」尚未提交结课申请，本课程无法开始。",
    "code_1_4": "虽然已经完成依存课程，但尚不满足依存天数"
  },
  "online_ja": {
    "attendance1": "该直播课已经结束，无法参加。",
    "attendance2": "如果您想手动参加，请使用「XXX」按钮。",
    "attendance3": "如果要重复使用 Web 会议室，请使用 XXX 按钮进入此Web会议室。",
    "join": "出席",
    "cancel": "取消",
    "rejoin": "再参加",
    "title": "确认",
    "title1": "请点击「XXX」按钮参加直播课。",
    "title2": "注意：如果由于无法打开直播课应用程序而导致无法参加直播课的话，请通过按「XXX」按钮直接加入，而不是通过StudyArts加入。 但是，如果您通过按「XXX」按钮直接参加，则无法自动设置出席状况，因此请在直播课结束后重新设置出席情况。",
    "draft": "立刻参加",
    "clickJump": "参加",
  }
}
export default zh;



// WEBPACK FOOTER //
// ./src/assets/languages/zh.js